module.exports = __webpack_public_path__ + "static/media/SharpSans-Semibold.cf166a92.woff2";